module.exports = __webpack_public_path__ + "06_bob_gray.60c14f55.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/06_bob_gray.png
// module id = HA8M
// module chunks = 0